<template>
  <el-dialog
    title="详情"
    :visible.sync="state"
    width="50%"
    :before-close="handleClose"
  >
    <div>
      <TzTable :height="300" :tableData="pageList" :columns="columnsEdit" />
    </div>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
import TzTable from '@/components/tz-table/Index.vue'
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    // user: Object,
    pageList: Array,
    columnsEdit: Array
  },
  components: {
    TzTable
  },
  data() {
    return {
      itempageList: [], //事项列表
      itemColumnsEdit: [
        {
          field: 'sort',
          title: '序号'
        },
        {
          field: 'itemType',
          title: '事项类型'
        },
        {
          field: 'itemName',
          title: '事项名称'
        },
        {
          field: 'resultValue',
          title: '检测结果默认值'
        },
        {
          field: 'qualifiedType',
          title: '检测合格类型'
        }
      ]
    }
  },

  methods: {
    // setup() {
    //   console.log(this.user)
    //   let params = {
    //     id: this.user.id
    //   }
    //   getList(params).then((res) => {
    //     if (res.code == 200) {
    //       this.itempageList = res.data.items ? res.data.items : []
    //     }
    //   })
    // },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style></style>
